import qs from 'query-string'
import { elementReady } from '@/core/startup/element-ready'
import _ from 'lodash'
import store from '@/store'
import { translate } from '@/core/localization'

function pushState(url) {
  if(window.history.pushState) {
    history.pushState({}, null, url)
  } else {
    this.redirectTo(url)
  }
}

function setQueryStringParameter(name, value) {
  if(!window.URLSearchParams || !window.history.replaceState) {
    return
  }
  const params = new URLSearchParams(window.location.search)
  params.set(name, value)
  window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`))
}

function getQueryStringParam(key) {
  const parsed = qs.parse(location.search)
  return parsed[key]
}

function removeQueryParam(param) {
  const url = new URL(window.location.href)
  url.searchParams.delete(param)
  window.history.replaceState({}, '', url)
}

function param(obj) {
  return qs.stringify(obj)
}

function getModelCode() {
  return getQueryStringParam('code') ? getQueryStringParam('code') : getQueryStringParam('currentVehicle')
}

function rememberScroll(key, scrollToSelector) {
  const cacheKey = `last_scroll_position`
  let savedScrollPositions = sessionStorage.getItem(cacheKey)
  savedScrollPositions = savedScrollPositions ? JSON.parse(savedScrollPositions) : {}

  window.addEventListener('scroll', _.throttle(function(e) {
    savedScrollPositions[key] = window.scrollY
    sessionStorage.setItem(cacheKey, JSON.stringify(savedScrollPositions))
  }), 200)

  const cachedScrollPosition = savedScrollPositions[key]
  if(cachedScrollPosition) {
    elementReady(scrollToSelector).then(() => {
      if('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: cachedScrollPosition,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo(0, cachedScrollPosition)
      }
    })
  }
}

function compare(o1, o2) {
  return _.reduce(o1, (result, value, key) => {
    if (_.isPlainObject(value)) {
      result[key] = compare(value, o2[key])
    } else if (!_.isEqual(value, o2[key])) {
      result[key] = value
    }
    return result
  }, {})
}

function savePhoneNumberWithFormating(number, countryCallingCode) {
  if (!number || !countryCallingCode) {
    return
  }

  return countryCallingCode + extractPhoneNumberFromFormating(number, countryCallingCode)
}

function extractPhoneNumberFromFormating(number, countryCallingCode) {
  if (number === null || number === '' || number === undefined) {
    return
  }

  let newNumber = number
  const zeroCallingCode = '00' + countryCallingCode.substring(1)

  if (newNumber.includes(countryCallingCode)) {
    newNumber = newNumber.replace(countryCallingCode, '')
  }

  if (newNumber.includes(zeroCallingCode) && newNumber.indexOf(zeroCallingCode) === 0) {
    newNumber = newNumber.replace(zeroCallingCode, '')
  }

  if (newNumber.charAt(0) === '0' || newNumber.charAt === 0) {
    newNumber = newNumber.substring(1)
  }

  return newNumber
}

function getVatPrefix(countryCode) {
  return countryCode === 'AT' ? 'ATU' : countryCode
}

function saveVatNumberWithFormating(number, countryCode) {
  if (number === null || number === '' || number === undefined || countryCode === undefined) {
    return
  }
  const prefix = getVatPrefix(countryCode)
  return prefix + number.trim().replaceAll('-', '') // Remove spaces and minus signs in case the user enters it
}

function extractVatNumberFromFormating(number, countryCode) {
  if (number === null || number === '' || number === undefined || countryCode === undefined) {
    return
  }
  const prefix = getVatPrefix(countryCode)
  if (number.length > prefix.length && number.substring(0, prefix.length) === prefix) {
    return number.substring(prefix.length)
  } else {
    return number
  }
}

function isElementInView(element) {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export function sharedText(key) {
  return translate(key, store.getters.clientModel.sharedId)
}

export default {
  pushState,
  getQueryStringParam,
  removeQueryParam,
  setQueryStringParameter,
  param,
  rememberScroll,
  compare,
  getModelCode,
  savePhoneNumberWithFormating,
  extractPhoneNumberFromFormating,
  saveVatNumberWithFormating,
  extractVatNumberFromFormating,
  isElementInView
}
